export enum RF_METHOD_TYPES {
     SAVE_CARD = "save-card",
     PAY_CC = "credit-card",
}

export enum RF_COLOR_CODES {
     WHITE = "#ffffff",
     BLUE = "#234dd0",
     GREY = "#495057",
     PAY_BTN_BLUE = "#6380db",
}


// WEBPACK FOOTER //
// ./src/common/credit-card/rf-components/constants.ts